import React from 'react';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
import { bytesToMB } from '../../../../utils/FormatUtils/formatMediaSize';
import { useStyles } from './SideBar.styles';
import PropTypes from 'prop-types';
import { Collections, Publish } from '@mui/icons-material';

const SideBar = ({ components, config, setSelected, selected }) => {
  const handleChangeContent = (component) => {
    setSelected(component);
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box sx={useStyles.menu}>
        {components.map((component, index) => (
          <Button
            key={component.label}
            sx={{
              ...useStyles.menuItem,
              ...(selected === index ? useStyles.selected : {}),
            }}
            onClick={() => handleChangeContent(index)}
          >
            {component.type === 'gallery' ? (
              <Collections fontSize="small" style={{ marginRight: '8px' }} />
            ) : (
              <Publish fontSize="small" style={{ marginRight: '8px' }} />
            )}
            {component.label}
          </Button>
        ))}
        <Typography sx={useStyles.spaceUsed}>
          {bytesToMB(config.used)} MB Used
        </Typography>
      </Box>
      <Box sx={useStyles.menuEnd}>
        <LinearProgress
          sx={useStyles.storageLinearProgress}
          variant="determinate"
          value={(config.used / config.quota) * 100}
        />
        <Typography sx={useStyles.availableText}>
          {`${(100 - (config.used / config.quota) * 100).toFixed(
            2
          )}% (${bytesToMB(config.quota - config.used)}MB) storage available`}
        </Typography>
      </Box>
    </Box>
  );
};

SideBar.propTypes = {
  components: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      label: PropTypes.string,
    })
  ),
  config: PropTypes.shape({
    used: PropTypes.number,
    quota: PropTypes.number,
  }),
  setSelected: PropTypes.func,
  selected: PropTypes.number,
};

export default SideBar;
